import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MobileContactDrawer from "./MobileContactDrawer";

/**
 * Drawer-only route. Used when App.jsx renders modal routes on top of a
 * backgroundLocation (so the background page remains visible).
 */
export default function MobileContactDrawerRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const { contactID } = useParams();

  const handleClose = () => {
    if (location.state?.backgroundLocation) {
      navigate(-1);
      return;
    }
    navigate("/contacts");
  };

  return (
    <MobileContactDrawer open={true} contactID={contactID} onClose={handleClose} />
  );
}


